module.exports = __webpack_public_path__ + "img/rotate.218f18b5.svg";